import React from 'react'

import { IconSizes, SealFullIcon } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'
import { useUserContext } from 'shared/hooks/useUserContext'

import styles from './FreeTrialSection.module.scss'

export const FreeTrialSection: React.FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_profile.free_trial'
  })
  const { user } = useUserContext()
  const { is_trial_account, trial_expiry } = user ?? {}

  const daysLeft = Math.max(
    0,
    trial_expiry
      ? Math.ceil((trial_expiry * 1000 - Date.now()) / (1000 * 60 * 60 * 24))
      : 0
  )

  if (!is_trial_account) return null

  return (
    <div className={styles.freeTrialSection}>
      <div className={styles.label}>
        <SealFullIcon
          className={styles.leadingIcon}
          size={IconSizes.Size16}
          color={'var(--warning-green-light)'}
        />
        {t('label')}
      </div>
      <p>{t('days_left', { count: daysLeft })}</p>
    </div>
  )
}
